import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';

let _is_mounted = false;

import moment from 'moment';
import { MonthView, TransitionView, Footer, Calendar } from 'react-date-picker';

import 'react-date-picker/index.css';

class NewTask extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      selectingDueDate: false,
      dueDateSelected: false,
      task: '',
      dueDate: Date.now(),
      reminderDate: null,
      clientId: this.props.client ? this.props.client._id : null,
      selectingAssignment: false,
      assignedTo: null,
      small_screen_display : false
    };

    this.handleResize = this.handleResize.bind(this);
    this.showAssignmentSelector = this.showAssignmentSelector.bind(this);
    this.onSelectAssignment = this.onSelectAssignment.bind(this);
    this.toggleShowDueDateSelector = this.toggleShowDueDateSelector.bind(this);
    this.toggleShowReminderDateSelector = this.toggleShowReminderDateSelector.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleResize() {
    if(_is_mounted) {
      if($(window).innerWidth() < 575) {
        if(!this.state.small_screen_display) {
          this.setState({small_screen_display : true})
        }
      }
      else if(this.state.small_screen_display) {
        this.setState({small_screen_display : false})
      }
    }
  }
  componentDidMount() {
    Api
      .getUsersInAccount()
      .then(users => {_is_mounted ? this.setState({users}) : null})
      .catch(this.props.notify);
  }
  onDateChange(date, {dateMoment}) {
    this.setState({
      dueDate: dateMoment.toDate(),
      dueDateSelected: true,
      selectingDueDate: false
    });
  }
  toggleShowDueDateSelector() {
    this.setState({
      selectingDueDate: !this.state.selectingDueDate,
      selectingReminderDate: false,
      selectingAssignment: false
    });
  }
  toggleShowReminderDateSelector() {
    this.setState({
      selectingReminderDate: !this.state.selectingReminderDate,
      selectingAssignment: false,
      selectingDueDate: false
    });
  }
  showAssignmentSelector() {
    this.setState({ selectingAssignment: !this.state.selectingAssignment, selectingDueDate: false });
  }
  updateTask(e) {
    this.setState({
      task: e.target.value
    });
  }
  onSelectAssignment(e) {
    this.setState({ assignedTo: e.target.value});
  }
  onSubmit(e) {
    if (e.key !== 'Enter' && e.key !== undefined) return;
    if (!this.state.task) {
      return this.props.notify({message: 'You must provide a task.'})
    }

    const task = {
      text: this.state.task,
      completed: false,
      assigned_to: this.state.assignedTo,
      client: this.props.client ? this.props.client._id : null,
      due_date: this.state.dueDate
    }

    // Send websocket request to create a new task and broadcast to connected users.
    this.props.sendSocketEmit(task, 'task-new');

    this.setState({
      selectingDueDate: false,
      selectingReminderDate: false,
      dueDateSelected: false,
      task: '',
      dueDate: '',
      clientId: this.props.client ? this.props.client._id : null,
      selectingAssignment: false,
      assignedTo: null,
    });
  }
  componentWillMount() {
    Api.getUsersInAccount()
      .then(users => {_is_mounted ? this.setState({users}) : null})
      .catch(this.props.notify);
  }
  componentDidMount() {
  	let _self = this;
    _is_mounted = true;

  	if($(window).innerWidth() < 575) {
  		this.setState({small_screen_display : true})
		}

  	$(window).resize(this.handleResize);
  }
  componentWillUnmount() {
    $(window).off('resize', this.handleResize);
    _is_mounted = false;
  }

  render() {
    const formattedDueDate = this.state.dueDate ? moment(this.state.dueDate).format('MM/DD') : '';
    const formattedRiminderDate = this.state.reminderDate ? moment(this.state.reminderDate).format('MM/DD') : '';
    return (
      <div className='new-task-container'>
				<div className='tasks-small-screen-view'>
	        <div className='input-group'>
	          <input
	          	type='text'
	          	value={this.state.task}
	          	onSubmit={this.onSubmit}
	          	onKeyPress={this.onSubmit}
	          	onChange={this.updateTask}
	          	className='form-control'
	          	placeholder='Add a task...'
	          />
	          <span className='input-group-btn'>
	          	<button
		          	title='Save'
		          	onClick={this.onSubmit}
		          	className='btn btn-primary new-task-submit-button mb-lg'
		          	>
								Submit
							</button>
	          </span>
	        </div>
          <div className='input-group mb-sm'>
    				<div
    				 	onClick={this.showAssignmentSelector}
    				 	title='Assign task'
    				 	className='input-group-addon tasks-small-view-buttons tasks-assignment-button btn-primary assign-user-button'
              >
	            <i className='fa fa-user' />
	          </div>
	          <div
	          	onClick={this.toggleShowDueDateSelector}
	          	title='Set due date'
	          	className='input-group-addon tasks-small-view-buttons tasks-calendar-button btn-primary date-selector-button'
	          	>
	            {(() => {
	              const hasDueDate = moment(this.state.dueDate).isValid();
	              return (hasDueDate ? `${formattedDueDate}` : <i className='fa fa-calendar'></i>);
	            })()}
	          </div>
            <div
	          	onClick={this.toggleShowReminderDateSelector}
	          	title='Set reminder date'
	          	className='input-group-addon tasks-small-view-buttons tasks-calendar-button btn-primary date-selector-button'
	          	>
	            {(() => {
	              const hasDueDate = moment(this.state.reminderDate).isValid();
	              return (hasDueDate ? `${formattedRiminderDate}` : <i className='fa fa-clock-o'></i>);
	            })()}
	          </div>
	        </div>
          {(() => {
	        	if(this.state.selectingAssignment) {
	        		return (
	        			<div
			          	className='task-assignment'
			          	style={{display: this.state.selectingAssignment ? '' : 'none' }}>
			            <span> Assign this task to the following user : &nbsp; </span>
			            <select
			            	className='input-sm'
			            	onChange={this.onSelectAssignment}
			            	value={this.state.assignedTo}>
			              <option value=' defaultValue='>-- SELECT USER --</option>
			              {
			                this.state.users.map((child_user, idx) => {
			                  return (
			                    <option key={idx} value={child_user._id}>{`${child_user.name.first} ${child_user.name.last} (${child_user.role})`}</option>
			                  );
			                })
			              }
			            </select>
			          </div>
        			)
	        	}
	        	else if(this.state.selectingDueDate) {
	        		return (
		      			<div className='due-date tasks-date-selector'>
				          <MonthView footer weekNumbers={false} onChange={ this.onDateChange }/>
				        </div>
        			)
	        	}
            else if(this.state.selectingReminderDate) {
              return (
                <div className='due-date tasks-date-selector'>
			            <Calendar dateFormat={'DD/MM/YYYY HH:mm'} onChange={ this.onDateChange } />
				        </div>
        			)
            }
	        })()}
        </div>
        <div className='tasks-large-screen-view'>
  				<div className='input-group input-group-lg mb-md'>
  				  <div
	  				 	onClick={this.showAssignmentSelector}
	  				 	title='Assign task'
	  				 	className='input-group-addon btn-primary assign-user-button'
	  				 	>
	            <i className='fa fa-user' />
	          </div>
		        <div
	          	onClick={this.toggleShowDueDateSelector}
	          	title='Set due date'
	          	className='input-group-addon btn-primary date-selector-button'
	          	>
	            {(() => {
	              const hasDueDate = moment(this.state.dueDate).isValid();
	              return (hasDueDate ? `${formattedDueDate}` : <i className='fa fa-calendar'></i>);
	            })()}
	          </div>
	          <input
	          	type='text'
	          	value={this.state.task}
	          	onSubmit={this.onSubmit}
	          	onKeyPress={this.onSubmit}
	          	onChange={this.updateTask}
	          	className='form-control input-lg'
	          	placeholder='Add a task...'
	          />
	          <div
	          	title='Save'
	          	className='input-group-addon btn-primary new-task-submit-button'
	          	onClick={this.onSubmit}
	          	>
							Submit
	          </div>
	        </div>
	        {(() => {
	        	if(this.state.selectingAssignment) {
	        		return (
	        			<div
			          	className='task-assignment'
			          	style={{display: this.state.selectingAssignment ? '' : 'none' }}>
			            <span> Assign this task to the following user : &nbsp; </span>
			            <select
			            	className='input-sm'
			            	onChange={this.onSelectAssignment}
			            	value={this.state.assignedTo}>
			              <option value=' defaultValue='>-- SELECT USER --</option>
			              {this.state.users.map((child_user, idx) => {
		                  return (
		                    <option
                          key={idx}
                          value={child_user._id}
                          >{`${child_user.name.first} ${child_user.name.last} (${child_user.role})`}
                        </option>
		                  );
		                })}
			            </select>
			          </div>
        			)
	        	}
	        	else if(this.state.selectingDueDate) {
	        		return (
		      			<div className='due-date tasks-date-selector pt-sm'>
                  <TransitionView>
                    <Calendar dateFormat={'DD/MM/YYYY HH:mm'} onChange={ this.onDateChange } />
                  </TransitionView>
				        </div>
        			)
	        	}
            else if(this.state.selectingReminderDate) {
              return (
		      			<div className='due-date tasks-date-selector'>
			            <Calendar dateFormat={'DD/MM/YYYY HH:mm'} onChange={ this.onDateChange } />
				        </div>
        			)
            }
	        })()}
        </div>
		  </div>
    );
  }
}

NewTask.propTypes = {
  users: PropTypes.object,
}

const mapStateToProps = ({users}) => ({users});

export default connect(mapStateToProps, Actions)(NewTask);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/newTask.js